<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="试卷类型：1exam 2test">-->
<!--                  <el-input  v-model="queryForm.paperType"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="试卷或测试ID">-->
<!--                  <el-input  v-model="queryForm.typeId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="题目">
<!--                  <el-input  v-model="queryForm.exerciseJson"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择试题" labelName="exerciseName" ref="gridSelectU"
                               labelValue="id" :value="queryForm.exerciseJson" :limit='1' size='small' placeholder='请选择试题'
                               @getValue="getSearchValueUser" :columns="EDUCLASSCOURSTESTPAPER_code" :searchs="EDUCLASSCOURSTESTPAPER_search" dataListUrl="/edu/exercise/findList" entityBeanName="eduExercise" queryEntityUrl="/edu/exercise/get">
                  </GridSelectU>
              </el-form-item>
<!--              <el-form-item label="序号">-->
<!--                  <el-input  v-model="queryForm.seq"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="正确率">-->
<!--                  <el-input  v-model="queryForm.knowledgeIds"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="考试人数">-->
<!--                  <el-input  v-model="queryForm.examStudent"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="正确人数">-->
<!--                  <el-input  v-model="queryForm.rightStudent"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduExerciseExamAnalysisList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addEduExerciseExamAnalysis"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editEduExerciseExamAnalysis(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduExerciseExamAnalysis(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshEduExerciseExamAnalysisList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduExerciseExamAnalysisList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="paperType"
        label="试卷类型"
        width="180"
      >
          <template slot-scope="scope">
              {{returnValue(scope.row.paperType)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="typeId"
        label="试卷或测试ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="exerciseJson"
        label="题目"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="seq"
        label="序号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="knowledgeIds"
        label="正确率"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="examStudent"
        label="考试人数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="rightStudent"
        label="正确人数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduExerciseExamAnalysis(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editEduExerciseExamAnalysis(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteEduExerciseExamAnalysis(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduExerciseExamAnalysisStates[eduExerciseExamAnalysisState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="eduExerciseExamAnalysis"
          ref="eduExerciseExamAnalysisForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="试卷类型"-->
<!--            prop="paperType"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExerciseExamAnalysis.paperType"-->
<!--              :disabled="eduExerciseExamAnalysisState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="试卷或测试ID"-->
<!--            prop="typeId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExerciseExamAnalysis.typeId"-->
<!--              :disabled="eduExerciseExamAnalysisState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="题目"
            prop="exerciseJson"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExerciseExamAnalysis.exerciseJson"-->
<!--              :disabled="eduExerciseExamAnalysisState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择试题" labelName="exerciseName" ref="gridSelectU" :disabled="eduExerciseExamAnalysisState == 'check'"
                           labelValue="id" :value="eduExerciseExamAnalysis.exerciseJson" :limit='1' size='small' placeholder='请选择试题'
                           @getValue="getValueUser" :columns="EDUCLASSCOURSTESTPAPER_code" :searchs="EDUCLASSCOURSTESTPAPER_search" dataListUrl="/edu/exercise/findList" entityBeanName="eduExercise" queryEntityUrl="/edu/exercise/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="序号"
            prop="seq"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduExerciseExamAnalysis.seq"
              :disabled="eduExerciseExamAnalysisState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="正确率"
            prop="knowledgeIds"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduExerciseExamAnalysis.knowledgeIds"
              :disabled="eduExerciseExamAnalysisState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="考试人数"
            prop="examStudent"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduExerciseExamAnalysis.examStudent"
              :disabled="eduExerciseExamAnalysisState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="正确人数"
            prop="rightStudent"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduExerciseExamAnalysis.rightStudent"
              :disabled="eduExerciseExamAnalysisState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduExerciseExamAnalysisState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/gidselect.vue';
import { EDUCLASSCOURSTESTPAPER, EDUCLASSCOURSTESTPAPER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduExerciseExamAnalysisList();
                    this.getEduExerciseExamAnalysisList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduExerciseExamAnalysisList();
                    this.getEduExerciseExamAnalysisList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     paperType: '', //试卷类型：1exam 2test
                     typeId: '', //试卷或测试ID
                     exerciseJson: '', //题目
                     seq: '', //序号
                     knowledgeIds: '', //正确率
                     examStudent: '', //考试人数
                     rightStudent: '', //正确人数
                },
                EDUCLASSCOURSTESTPAPER_code: EDUCLASSCOURSTESTPAPER,
                EDUCLASSCOURSTESTPAPER_search: EDUCLASSCOURSTESTPAPER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduExerciseExamAnalysisState: 'add',
                eduExerciseExamAnalysisStates: {
                    add: '新建测试分析',
                    check: '查看测试分析',
                    edit: '修改测试分析'
                },

                multipleSelection: [],
                eduExerciseExamAnalysisList: [],
                eduExerciseExamAnalysis: {
                    id: '',
                    paperType: '', //试卷类型
                    typeId: '', //试卷或测试ID
                    exerciseJson: '', //题目
                    seq: '', //序号
                    knowledgeIds: '', //正确率
                    examStudent: '', //考试人数
                    rightStudent: '', //正确人数
                },
                btnLoading: false,
                paperTypeList: [],
                rules: {
                    paperType: [{ required: true, message: '试卷类型不能为空', trigger: 'blur' }],
                    typeId: [{ required: true, message: '试卷或测试ID不能为空', trigger: 'blur' }],
                    exerciseJson: [{ required: true, message: '题目不能为空', trigger: 'blur' }],
                    seq: [{ required: true, message: '序号不能为空', trigger: 'blur' }],
                    knowledgeIds: [{ required: true, message: '正确率不能为空', trigger: 'blur' }],
                    examStudent: [{ required: true, message: '考试人数不能为空', trigger: 'blur' }],
                    rightStudent: [{ required: true, message: '正确人数不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            //
            this.getEumn();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(val, sign){
                this.eduExerciseExamAnalysis.typeId = val;
                this.queryForm.typeId = val;
                this.eduExerciseExamAnalysis.paperType = sign;
                this.queryForm.paperType = sign;
                this.getEduExerciseExamAnalysisList();
            },
            returnValue(key){
                for (let item of this.paperTypeList) {
                    if(item.key == key){
                        return item.value;
                    }
                }
            },
            getEumn(){
                get('/edu/utils/getEnum', { enumType: 'paper_type' }).then((res) => {
                    if (res.success && res.code == 200) {
                        this.paperTypeList = res.enumList;
                    }
                });
            },
            getValueUser(value){
                this.eduExerciseExamAnalysis.exerciseJson =value;
            },
            getSearchValueUser(value){
                this.queryForm.exerciseJson =value;
            },
            resetEduExerciseExamAnalysisList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduExerciseExamAnalysisList = [];
            },
            resetDialog() {
                this.eduExerciseExamAnalysisState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      paperType: this.queryForm.paperType, //试卷类型：1exam 2test
                      typeId: this.queryForm.typeId, //试卷或测试ID
                      exerciseJson: '', //题目
                      seq: '', //序号
                      knowledgeIds: '', //正确率
                      examStudent: '', //考试人数
                      rightStudent: '', //正确人数
                };
                this.getEduExerciseExamAnalysisList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduExerciseExamAnalysis = {
                      id: '', //
                      paperType: this.eduExerciseExamAnalysis.paperType, //试卷类型：1exam 2test
                      typeId: this.eduExerciseExamAnalysis.typeId, //试卷或测试ID
                      exerciseJson: '', //题目
                      seq: '', //序号
                      knowledgeIds: '', //正确率
                      examStudent: '', //考试人数
                      rightStudent: '', //正确人数
                };
            },
            submitForm() {
                if (this.eduExerciseExamAnalysisState == 'add') {
                    this.$refs.eduExerciseExamAnalysisForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/exerciseexamanalysis/add`,{ ...this.eduExerciseExamAnalysis }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduExerciseExamAnalysisList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduExerciseExamAnalysisState == 'edit') {
                    this.$refs.eduExerciseExamAnalysisForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/exerciseexamanalysis/edit`,{ ...this.eduExerciseExamAnalysis }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduExerciseExamAnalysisList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduExerciseExamAnalysis() {
                this.showDialog = true;
                this.eduExerciseExamAnalysisState = 'add';
            },
            checkEduExerciseExamAnalysis(eduExerciseExamAnalysisId) {
                console.log(eduExerciseExamAnalysisId);
                this.currentEduExerciseExamAnalysisId = eduExerciseExamAnalysisId;

                this.getEduExerciseExamAnalysisById();
                this.showDialog = true;
                this.eduExerciseExamAnalysisState = 'check';
            },
            editEduExerciseExamAnalysis(eduExerciseExamAnalysisId) {
                console.log('eduExerciseExamAnalysis', eduExerciseExamAnalysisId);
                if (eduExerciseExamAnalysisId) {
                    this.currentEduExerciseExamAnalysisId = eduExerciseExamAnalysisId;
                    this.getEduExerciseExamAnalysisById();
                } else {
                    this.eduExerciseExamAnalysis = { ...this.eduExerciseExamAnalysis, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduExerciseExamAnalysisState = 'edit';
            },
            deleteEduExerciseExamAnalysis(eduExerciseExamAnalysisId) {
                let ids = '';
                if (eduExerciseExamAnalysisId) {
                    ids = eduExerciseExamAnalysisId;
                } else {
                    ids = this.multipleSelection.map((eduExerciseExamAnalysis) => eduExerciseExamAnalysis.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/exerciseexamanalysis/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduExerciseExamAnalysisList();
                                this.getEduExerciseExamAnalysisList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduExerciseExamAnalysisList() {
                this.resetEduExerciseExamAnalysisList();
                this.getEduExerciseExamAnalysisList();
            },
            getEduExerciseExamAnalysisList(query = {}) {
                this.loading = true;
                get(`/edu/exerciseexamanalysis/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduExerciseExamAnalysisList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduExerciseExamAnalysisById() {
                get(`/edu/exerciseexamanalysis/get`,{ id: this.currentEduExerciseExamAnalysisId }).then((res) =>{
                    if(res.success){
                      this.eduExerciseExamAnalysis = { ...this.eduExerciseExamAnalysis, ...res.eduExerciseExamAnalysis };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduExerciseExamAnalysisList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/exerciseexamanalysis/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/exerciseexamanalysis/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/exerciseexamanalysis/importData`,formData);
              this.refreshEduExerciseExamAnalysisList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduExerciseExamAnalysisList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduExerciseExamAnalysisList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>